<template>
  <div class=" is-fullwidth">
    <div class="buttons" >
        <button class="button " v-bind:class="{'is-success': makeup_location_id == row.id}" v-for="row in makeuplocations" :key="row.id" @click="makeup_location_id=row.id">{{ row.name }}</button> 
    </div>
    
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th>Range</th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Scheduler</th>
    	</thead>
    	<tbody>
		    <tr v-if="loading === true">
                <td colspan="9" ><div class="notification is-info">Loading orders ...</div></td>
            </tr>
            <tr v-if="loading == false && filteredOrders.length == 0">
                <td colspan="9" ><div class="notification is-warning">There are no orders to show</div></td>
            </tr>
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.range_name}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td><span class="tag is-success" v-if="order.exported_to_scheduler==1">Exported</span></td>
          
          
              
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate ASC',
      makeup_location_id: ''
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getProductionMakeupAllocated(this.accessToken, this.order_by, this.makeup_location_id)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function() { // Rmeoved u from parameters
            //if(  u.in_progress == 0) 
           // {
              return 1
           // }
          })
          

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           
           this.getMakeupLocations();
        });
  },
 
  mounted() {
    if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }
      
  },
  watch: {
    makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },
  }
}


</script>

